import {
   HealthcareProviderWaitlistTimeSlotReservedPatientNotificationEnabledSetCommand,
   HealthcareProviderWaitlistTimeSlotReservedTokenInConfirmationEnabledQuery,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { patientPhoneNotificationTranslationKeys } from '../../translations';

import { PatientPhoneNotificationWaitlistProposedAppointmentToggleFormBean } from './PatientPhoneNotificationWaitlistProposedAppointmentToggle.types';

export const useCurrentHealthcareProviderWaitlistTimeSlotReservedPatientNotificationEnabledSetCommand = (
   onSuccess: VoidFunction
): UseCqrsCommandResult<void, PatientPhoneNotificationWaitlistProposedAppointmentToggleFormBean> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new HealthcareProviderWaitlistTimeSlotReservedPatientNotificationEnabledSetCommand();
         command.enabled = Choice.of(parameters.notificationEnabled ?? false);
         return command;
      },
      {
         onSuccess: (ignore, parameters) => {
            dispatchSnackbarPositiveEvent(
               parameters.notificationEnabled
                  ? patientPhoneNotificationTranslationKeys.notificationToggle.waitlistProposedAppointmentToggleSaveOn
                  : patientPhoneNotificationTranslationKeys.notificationToggle.waitlistProposedAppointmentToggleSaveOff
            );
            onSuccess();
            refetchCqrsQuery(HealthcareProviderWaitlistTimeSlotReservedTokenInConfirmationEnabledQuery);
         },
      }
   );
};
